<div class="p-5 max-w-[1600px] mx-auto">
  <!-- Header -->
  <div class="flex justify-between items-center mb-5">
    <h1 class="text-2xl font-medium">{{ 'customers.list.title' | translate }}</h1>
    <button mat-flat-button (click)="navigateToCreate()">
      <mat-icon>add</mat-icon>
      {{ 'customers.list.create' | translate }}
    </button>
  </div>

  <!-- Search + column picker -->
  <div class="flex gap-3 mb-4 items-center">
    <mat-form-field class="flex-1" subscriptSizing="dynamic">
      <mat-label>{{ 'customers.list.search-placeholder' | translate }}</mat-label>
      <input #searchBox matInput [value]="searchInput()" (input)="onSearchInput(searchBox.value)" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <button
      mat-icon-button
      [matMenuTriggerFor]="columnMenu"
      matTooltip="{{ 'customers.list.column-picker' | translate }}">
      <mat-icon>view_column</mat-icon>
    </button>
  </div>

  <mat-card>
    <mat-card-content class="!p-0">
      <div class="overflow-x-auto">
        <table
          mat-table
          [dataSource]="customers()"
          class="w-full">

              <!-- ID Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.id' | translate }}</th>
                <td mat-cell *matCellDef="let c">{{ c.id }}</td>
              </ng-container>

              <!-- First Name Column -->
              <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.firstName' | translate }}</th>
                <td mat-cell *matCellDef="let c">{{ c.firstName }}</td>
              </ng-container>

              <!-- Last Name Column -->
              <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.lastName' | translate }}</th>
                <td mat-cell *matCellDef="let c">{{ c.lastName }}</td>
              </ng-container>

              <!-- Email Column -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.email' | translate }}</th>
                <td mat-cell *matCellDef="let c">{{ c.email }}</td>
              </ng-container>

              <!-- Gender Column -->
              <ng-container matColumnDef="genderName">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.gender' | translate }}</th>
                <td mat-cell *matCellDef="let c">{{ codeListsService.genderMap().get(c.genderId) }}</td>
              </ng-container>

              <!-- Address Column -->
              <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.address' | translate }}</th>
                <td mat-cell *matCellDef="let c">{{ c.address }}</td>
              </ng-container>

              <!-- Postal Code Column -->
              <ng-container matColumnDef="postalCode">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.postalCode' | translate }}</th>
                <td mat-cell *matCellDef="let c">{{ c.postalCode }}</td>
              </ng-container>

              <!-- City Column -->
              <ng-container matColumnDef="city">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.city' | translate }}</th>
                <td mat-cell *matCellDef="let c">{{ c.city }}</td>
              </ng-container>

              <!-- Country Column -->
              <ng-container matColumnDef="countryName">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.country' | translate }}</th>
                <td mat-cell *matCellDef="let c">{{ codeListsService.countryMap().get(c.countryId) }}</td>
              </ng-container>

              <!-- Phone Column -->
              <ng-container matColumnDef="phoneNumber">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.phoneNumber' | translate }}</th>
                <td mat-cell *matCellDef="let c">{{ c.phoneNumber }}</td>
              </ng-container>

              <!-- Birth Date Column -->
              <ng-container matColumnDef="birthDate">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.birthDate' | translate }}</th>
                <td mat-cell *matCellDef="let c" class="whitespace-nowrap">{{ c.birthDate | date: 'mediumDate' }}</td>
              </ng-container>

              <!-- Created On Column -->
              <ng-container matColumnDef="createdOn">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.createdOn' | translate }}</th>
                <td mat-cell *matCellDef="let c" class="whitespace-nowrap">{{ c.createdOn | date: 'mediumDate' }}</td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="statusName">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.status' | translate }}</th>
                <td mat-cell *matCellDef="let c">
                  <span
                    class="px-2 py-0.5 rounded text-xs font-medium"
                    [class]="getStatusClass(c.statusId)">
                    {{ codeListsService.statusMap().get(c.statusId) }}
                  </span>
                </td>
              </ng-container>

              <!-- Site Column -->
              <ng-container matColumnDef="siteName">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.site' | translate }}</th>
                <td mat-cell *matCellDef="let c">{{ codeListsService.siteMap().get(c.siteId) }}</td>
              </ng-container>

              <!-- App Account Column -->
              <ng-container matColumnDef="hasAppAccount">
                <th mat-header-cell *matHeaderCellDef>{{ 'customers.col.hasAppAccount' | translate }}</th>
                <td mat-cell *matCellDef="let c"><app-bool [value]="c.hasAppAccount" /></td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="!w-24"></th>
                <td mat-cell *matCellDef="let c">
                  <div class="flex items-center">
                    <button
                      mat-icon-button
                      color="primary"
                      (click)="$event.stopPropagation(); navigateToCustomer(c.id)"
                      matTooltip="{{ 'customers.list.edit' | translate }}">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      color="warn"
                      (click)="deleteCustomer(c, $event)"
                      matTooltip="{{ 'customers.list.delete' | translate }}">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <!-- ─── Filter header columns (generated from column definitions) ─── -->

              @for (col of allColumns; track col.key) {
                <ng-container [matColumnDef]="'filter-' + col.key">
                  <th mat-header-cell *matHeaderCellDef [class.!p-1]="col.filterType !== 'none'">
                    @switch (col.filterType) {
                      @case ('text') {
                        <mat-form-field subscriptSizing="dynamic" class="w-full">
                          <input #filterBox matInput
                            placeholder="{{ 'customers.filter.placeholder' | translate }}"
                            [value]="getTextFilterValue(col.filterField!)"
                            (input)="onTextFilterInput(col.filterField!, filterBox.value)" />
                        </mat-form-field>
                      }
                      @case ('dropdown') {
                        <mat-form-field subscriptSizing="dynamic" class="w-full">
                          <mat-select
                            [value]="getDropdownFilterValue(col.filterField!)"
                            (selectionChange)="onDropdownFilterChange(col.filterField!, $event.value)">
                            <mat-option value="">{{ 'customers.filter.all' | translate }}</mat-option>
                            @for (opt of dropdownSources[col.dropdownSource!](); track opt.id) {
                              <mat-option [value]="opt.id">{{ opt.name }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      @case ('boolean') {
                        <mat-form-field subscriptSizing="dynamic" class="w-full">
                          <mat-select
                            [value]="getBooleanFilterValue(col.filterField!)"
                            (selectionChange)="onDropdownFilterChange(col.filterField!, $event.value)">
                            <mat-option value="">{{ 'customers.filter.all' | translate }}</mat-option>
                            <mat-option [value]="true">{{ 'customers.filter.yes' | translate }}</mat-option>
                            <mat-option [value]="false">{{ 'customers.filter.no' | translate }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      }
                      @case ('number') {
                        <mat-form-field subscriptSizing="dynamic" class="w-full">
                          <input matInput type="number"
                            placeholder="{{ 'customers.filter.placeholder' | translate }}"
                            [value]="getRangeFilterValue(col.filterField!)"
                            (input)="onRangeFilterChange(col.filterField!, $any($event.target).value, true)" />
                        </mat-form-field>
                      }
                      @case ('daterange') {
                        <div class="flex gap-1 items-center">
                          <mat-form-field subscriptSizing="dynamic" class="flex-1">
                            <mat-label>{{ 'customers.filter.from' | translate }}</mat-label>
                            <input matInput [matDatepicker]="fromPicker"
                              [value]="getDateFilterValue(col.filterFieldFrom!)"
                              (dateChange)="onDateFilterChange(col.filterFieldFrom!, $event.value)" />
                            @if (getDateFilterValue(col.filterFieldFrom!)) {
                              <button matIconSuffix mat-icon-button type="button"
                                (click)="onDateFilterChange(col.filterFieldFrom!, null)"
                                matTooltip="{{ 'customers.filter.clear' | translate }}"
                                [attr.aria-label]="'customers.filter.clear' | translate">
                                <mat-icon>close</mat-icon>
                              </button>
                            } @else {
                              <mat-datepicker-toggle matIconSuffix [for]="fromPicker" />
                            }
                            <mat-datepicker #fromPicker />
                          </mat-form-field>
                          <span class="text-gray-400 text-xs">→</span>
                          <mat-form-field subscriptSizing="dynamic" class="flex-1">
                            <mat-label>{{ 'customers.filter.to' | translate }}</mat-label>
                            <input matInput [matDatepicker]="toPicker"
                              [value]="getDateFilterValue(col.filterFieldTo!)"
                              (dateChange)="onDateFilterChange(col.filterFieldTo!, $event.value)" />
                            @if (getDateFilterValue(col.filterFieldTo!)) {
                              <button matIconSuffix mat-icon-button type="button"
                                (click)="onDateFilterChange(col.filterFieldTo!, null)"
                                matTooltip="{{ 'customers.filter.clear' | translate }}"
                                [attr.aria-label]="'customers.filter.clear' | translate">
                                <mat-icon>close</mat-icon>
                              </button>
                            } @else {
                              <mat-datepicker-toggle matIconSuffix [for]="toPicker" />
                            }
                            <mat-datepicker #toPicker />
                          </mat-form-field>
                        </div>
                      }
                    }
                  </th>
                </ng-container>
              }

              <ng-container matColumnDef="filter-actions">
                <th mat-header-cell *matHeaderCellDef class="!w-24"></th>
              </ng-container>

              <!-- ─── No-data row ─── -->
              <tr *matNoDataRow>
                @if (!customersResource.isLoading()) {
                  <td [attr.colspan]="displayedColumns().length" class="p-0">
                    <div class="text-center p-10">
                      <mat-icon class="!text-6xl !w-16 !h-16 !text-gray-400 mb-4">people</mat-icon>
                      <p class="text-gray-700 text-base">{{ 'customers.list.no-customers' | translate }}</p>
                    </div>
                  </td>
                }
              </tr>

              <!-- ─── Row definitions ─── -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
              <tr mat-header-row *matHeaderRowDef="filterColumns()" class="filter-row"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns()"
                (click)="navigateToCustomer(row.id)"
                class="cursor-pointer hover:bg-gray-50"></tr>
            </table>
          </div>

          @if (totalCount() > 0) {
            <mat-paginator
              [length]="totalCount()"
              [pageSize]="pageSize()"
              [pageIndex]="page() - 1"
              [pageSizeOptions]="[10, 25, 50, 100]"
              [showFirstLastButtons]="true"
              (page)="onPageChange($event)"
              class="border-t border-gray-200" />
          }
    </mat-card-content>
  </mat-card>
</div>

<!-- Column picker menu (stays open while interacting with checkboxes) -->
<mat-menu #columnMenu="matMenu">
  <div class="px-2 py-1 min-w-48" (click)="$event.stopPropagation()">
    <p class="text-xs font-medium text-gray-500 uppercase tracking-wider px-2 pb-2">
      {{ 'customers.list.column-picker' | translate }}
    </p>
    @for (col of allColumns; track col.key) {
      <div class="flex items-center px-2 py-1">
        <mat-checkbox [checked]="isColumnVisible(col.key)" (change)="toggleColumn(col.key)">
          {{ col.labelKey | translate }}
        </mat-checkbox>
      </div>
    }
  </div>
</mat-menu>
